// 自动加载 src/assets/icons 下所有 .svg，注册为 svg-sprite
// webpack require.context 等价于 Vite 的 import.meta.glob
const req = require.context('@/assets/icons', false, /\.svg$/);
req.keys().forEach(req);

export default req;
